import { coverUrl } from "@/lib/api";
import { formatPostDateShort } from "@/lib/date";

const Thumb = ({ post }) => {
  const cu = coverUrl(post);
  if (cu) {
    return (
      <img
        src={cu}
        alt=""
        className="w-full h-full object-cover"
        loading="lazy"
      />
    );
  }
  if (post.youtube_id) {
    return (
      <div className="relative w-full h-full bg-[#1a1918]">
        <img
          src={`https://img.youtube.com/vi/${post.youtube_id}/mqdefault.jpg`}
          alt=""
          className="w-full h-full object-cover opacity-80"
          loading="lazy"
        />
        <span className="absolute inset-0 flex items-center justify-center text-[#f9f8f6] font-serif text-2xl">▸</span>
      </div>
    );
  }
  return (
    <div className="w-full h-full bg-[#f2efe9] border border-[#e5e1d8] flex items-center justify-center">
      <span className="font-serif text-3xl text-[#d4b886]">A</span>
    </div>
  );
};

const PostListRow = ({ post, onOpen, variant = "default" }) => {
  // variant "compact" → thumb a bit smaller
  const thumbSize = variant === "compact"
    ? "w-20 h-20 sm:w-24 sm:h-24"
    : "w-24 h-24 sm:w-32 sm:h-32";

  return (
    <button
      type="button"
      data-testid={`post-row-${post.id}`}
      onClick={() => onOpen(post.id)}
      className="group w-full flex items-center gap-4 sm:gap-6 py-4 sm:py-5 text-left hover:bg-[#f2efe9] px-2 sm:px-3 -mx-2 sm:-mx-3 transition-colors"
    >
      <div className={`${thumbSize} shrink-0 overflow-hidden`}>
        <Thumb post={post} />
      </div>
      <div className="flex-1 min-w-0">
        <p className="font-sans text-[10px] tracking-[0.25em] uppercase text-[#4a4843] mb-1.5">
          {formatPostDateShort(post.created_at)}
        </p>
        <h3 className="font-serif text-lg sm:text-2xl leading-tight tracking-tight text-[#1a1918] group-hover:text-[#4a4843] transition-colors line-clamp-2">
          {post.title}
        </h3>
        {post.author && (
          <p className="font-serif italic text-sm sm:text-base text-[#4a4843] mt-1.5">
            di {post.author}
          </p>
        )}
      </div>
      <span className="hidden sm:inline-block shrink-0 font-sans text-[10px] tracking-[0.3em] uppercase text-[#1a1918] border-b border-[#d4b886] pb-0.5 ml-2">
        leggi →
      </span>
    </button>
  );
};

export default PostListRow;
